import React from 'react';
import { useEffect, useState } from 'react';
import {
  MCText,
  RadiosField,
  SelectField,
  TextField,
  ToggleSwitch,
  View
} from 'src/components/basic';
import LANG_CONST from 'src/helpers/lang/const';
import { objectToSelectList, remCss } from 'src/helpers';
import { ExpandAnimationComponent } from 'src/components/Form';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';

function SelfDestruct({ onChange }) {
  // State management
  const [isEnabled, setIsEnabled] = useState(false);
  const [type, setType] = useState('first_view');
  const [delay, setDelay] = useState(10);
  const [unit, setUnit] = useState('minutes');

  useEffect(() => {
    onChange(
      isEnabled && delay > 0
        ? {
            type: type,
            expireInSeconds:
              delay * (unit === 'minutes' ? 60 : unit === 'hours' ? 60 * 60 : 24 * 60 * 60)
          }
        : null
    );
  }, [isEnabled, type, delay, unit]);

  // Toggle switch handler
  const handleToggle = () => {
    setIsEnabled((prev) => !prev);
  };

  return (
    <View style={{ paddingTop: remCss(20), marginTop: remCss(5) }} className='mc-bt'>
      <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: remCss(10) }}>
          <SVGIcon iconname={BASE_ICONS.CLOCK} width={remCss(30)} />
          <MCText
            label={LANG_CONST.timer}
            size={20}
            lineHeight={20}
            style={{ marginTop: remCss(3) }}
          />
        </View>
        <ToggleSwitch
          checked={isEnabled}
          onChange={() => {
            handleToggle();
          }}
        />
      </View>
      <ExpandAnimationComponent show={isEnabled} dropdown={false}>
        <View style={{ padding: remCss(15), gap: remCss(15) }}>
          <View style={{ flexDirection: 'row', gap: remCss(20) }}>
            <RadiosField
              template={'2'}
              list={[
                { value: 'first_view', label: LANG_CONST.first_view },
                { value: 'upload', label: LANG_CONST.expire_in }
              ]}
              data={type}
              onChange={(e) => setType(e)}
            />
          </View>
          <MCText label={LANG_CONST.delay} />
          <View style={{ flexDirection: 'row', gap: remCss(20) }}>
            <View>
              <TextField
                template={6}
                style={{ width: remCss(120) }}
                name={'delay'}
                value={delay}
                type={'number'}
                onChange={(n, v) => {
                  if (v > 9999 || parseInt(v) !== v) return;
                  setDelay(v);
                }}
              />
            </View>
            <View style={{ flex: 1 }}>
              <SelectField
                template={6}
                name={'unit'}
                options={objectToSelectList(LANG_CONST.constants.self_destruct_unit)}
                value={unit}
                onChange={(n, v) => setUnit(v)}
                isClearable={false}
              />
            </View>
          </View>
        </View>
      </ExpandAnimationComponent>
    </View>
  );
}

export default SelfDestruct;
